export const APPREDUCER =  (state = { showPreloader: false }, action) => {
  switch(action.type){
    case 'TOGGLE_PRELOADER':
      return {
        showPreloader: action.data
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/App/AppReducer.js